var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var CalendarIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 49,
    glyphHeight: 52,
    glyphOffsetY: -2
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4111 4.95957V3.06866C33.4111 1.49921 34.6956 0.2323 36.287 0.2323C37.8783 0.2323 39.1628 1.49921 39.1628 3.06866V4.95957H43.9559C46.6017 4.95957 48.749 7.07739 48.749 9.68685V47.505C48.749 50.1145 46.6017 52.2323 43.9559 52.2323H5.6112C2.96542 52.2323 0.818115 50.1145 0.818115 47.505V9.68685C0.818115 7.07739 2.96542 4.95957 5.6112 4.95957H10.4043V3.06866C10.4043 1.49921 11.6888 0.2323 13.2801 0.2323C14.8714 0.2323 16.156 1.49921 16.156 3.06866V4.95957H33.4111ZM42.9973 21.9778H6.56982V46.5596H42.9973V21.9778ZM42.9973 16.305V10.6323H6.56982V16.305H42.9973Z"
  }));
};
export var CalendarIconGlyph = function (props) {
  return React.createElement(CalendarIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};